import { firstNumber, firstPresent, safeText } from './chatArtifactValueUtils';

function normalizeEvidenceReferences(references) {
  if (!Array.isArray(references)) return [];
  return references.filter((reference) => reference && typeof reference === 'object');
}

function generatedColumnEntries(generatedColumns) {
  if (Array.isArray(generatedColumns)) return generatedColumns;
  if (generatedColumns && typeof generatedColumns === 'object') {
    return Object.entries(generatedColumns).map(([key, column]) => ({
      key,
      ...(column && typeof column === 'object' ? column : {}),
    }));
  }
  return [];
}

export function normalizeGeneratedCell(cell) {
  if (!cell || typeof cell !== 'object') {
    return {
      generatedCell: true,
      value: safeText(cell),
      evidenceRefs: [],
    };
  }

  return {
    generatedCell: true,
    value: safeText(firstPresent(cell.value, cell.display_value, cell.answer)),
    status: firstPresent(cell.status, cell.state),
    evidenceRefs: normalizeEvidenceReferences(firstPresent(cell.evidence_refs, cell.evidence_references)),
    disclosure: firstPresent(cell.disclosure_message, cell.disclosure_label, cell.disclosure),
    refreshStatus: firstPresent(cell.refresh_status, cell.refreshStatus),
  };
}

export function normalizeGeneratedColumns(artifact) {
  return generatedColumnEntries(artifact?.generated_columns)
    .map((column) => {
      const key = firstPresent(column?.key, column?.field);
      const label = firstPresent(column?.label, column?.headerName, key);
      if (!key || !label) return null;
      return {
        key,
        label,
        minWidth: firstNumber(column?.minWidth, column?.min_width) || 180,
        generated: true,
      };
    })
    .filter(Boolean);
}
